import {State_Impl_} from "../tink/state/State"
import {Register} from "../genes/Register"

export const Location = Register.global("$hxClasses")["spectatory.Location"] = 
class Location {
	static get __name__() {
		return "spectatory.Location"
	}
	get __class__() {
		return Location
	}
}


Location.href = (function($this) {var $r0
	let s = State_Impl_._new(window.location.href);
	
			(function () {
				if ( typeof window.CustomEvent === "function" ) return;
				function CustomEvent ( event, params ) {
					params = params || { bubbles: false, cancelable: false, detail: undefined };
					var evt = document.createEvent( "CustomEvent" );
					evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
					return evt;
				}
				CustomEvent.prototype = window.Event.prototype;
				window.CustomEvent = CustomEvent;
			})();
		;
	let update = function (href) {
		if (href != State_Impl_.get_value(s)) {
			s.set(href);
		};
	};
	let oldPushState = (o=>Register.bind(o, o.pushState))(window.history);
	window.history.pushState = function (data, title, url = null) {
		oldPushState(data, title, url);
		update(window.location.href);
	};
	let oldReplaceState = (o=>Register.bind(o, o.replaceState))(window.history);
	window.history.replaceState = function (data, title, url = null) {
		oldReplaceState(data, title, url);
		update(window.location.href);
	};
	window.addEventListener("popstate", function (_) {
		update(window.location.href);
	});
	window.addEventListener("hashchange", function (e) {
		update(e.newURL);
	});
	
	$r0 = s
	return $r0})(this)